module.exports = __webpack_public_path__ + "static/media/Screenshot 2.39814cb5.JPG";